import { render, staticRenderFns } from "./enviarVia.vue?vue&type=template&id=2b98f292&scoped=true"
import script from "./enviarVia.vue?vue&type=script&lang=js"
export * from "./enviarVia.vue?vue&type=script&lang=js"
import style0 from "./enviarVia.vue?vue&type=style&index=0&id=2b98f292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98f292",
  null
  
)

export default component.exports